import React from 'react';
import { useDispatch } from 'react-redux';

import { keycloak } from '@/Routing/keycloak';
import { setUser, User } from '@/StateManagement/AuthReducer';

const keycloakPromise: Promise<boolean> = keycloak.init({
  checkLoginIframe: true,
  onLoad: 'login-required',
});

const PublicRoutes: React.FC = (): React.ReactElement => {
  const dispatch = useDispatch();

  React.useLayoutEffect((): void => {
    // We intentionally ignore the promise, this can happen async, and we still
    // can render the login page anyway
    keycloakPromise
      .then((result: boolean): Promise<User | null> => {
        if (result) {
          const { token, tokenParsed } = keycloak;
          if (!token || !tokenParsed) {
            throw new Error(
              'token or tokenParsed is missing, this is a bug because we are supposedly logged in now',
            );
          }

          return Promise.resolve(User.fromKeycloakToken(token, tokenParsed));
        } else {
          console.debug('Failed to authenticate');
          return Promise.resolve(null);
        }
      })
      .then((user: User | null): void => {
        dispatch(setUser(user));
      })
      .catch(console.warn);
  }, [dispatch]);

  return <></>;
};

export default PublicRoutes;
